export default function (category: string) {
  switch (category) {
    case 'show':
      return 'Sendung'
    case 'episode':
      return 'Ausgabe'
    case 'page':
      return 'Seite'
    case 'news post':
      return 'Aktuell'
    default:
      break
  }
}
